import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import appDisplay from 'scoreboard/components/app-display'
import HistoryInfo from 'scoreboard/components/history-info'

function url(model) {
	var url = 'api/calendars/' + model.id + '/history'
	return url
}

var CalendarHistoryInfo = HistoryInfo.extend({

	className: 'calendar-history-info',

	events: {
		'click .export' : 'sendTo'
	},

	initialize: function(options) {
		this.options = options
		this.label = this.options.label
		this.export = this.options.export
		this.section = this.options.section
		this.full = true
		this.headerText = this.export ? this.exportLabel() : i18n.get('common.auditWithLabel', this.label)
		HistoryInfo.prototype.initialize.apply(this, arguments)
	},

	renderHistory: function(history) {
		HistoryInfo.prototype.renderHistory.apply(this, arguments)
		this.$('.calendar-history-type').removeClass('is-not-displayed')
		this.$('.toggle-container').remove()
	}

}, {

	display: function (model, label) {
		appDisplay.dialog($.get(url(model)), function (response) {
			return new CalendarHistoryInfo({model: model, history: response.history, label: label})
		}.bind(this))
	}

})

export default CalendarHistoryInfo


CalendarHistoryInfo.__filename__ = 'admin/calendars/calendar-history-info.js'
